import { render, staticRenderFns } from "./SystemSetting.vue?vue&type=template&id=cd9b764c&"
import script from "./SystemSetting.vue?vue&type=script&lang=ts&"
export * from "./SystemSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports